import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Input, Button, Select, Form, Space, DatePicker, Upload, message } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"
import { formItemLayout, tailLayout, ngetBase64 } from '../../js/globalParam'
import { apiPrefix } from '../../js/config'
import moment from 'moment';
import _ from 'lodash'

const { Option } = Select
const dateFormat = 'YYYY-MM-DD';

function beforeUpload(file: { type: string; size: number }) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'

    if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG格式的图片文件!')
    }

    const isLt3M = file.size / 1024 / 1024 < 3

    if (!isLt3M) {
        message.error('上传图片不能大于3MB!')
    }

    return isJpgOrPng && isLt3M
}

export default function CoperationEdit() {

    const { id }: { id: string | undefined } = useParams()
    const [form] = useForm()

    const [pageTitle, setPageTitle] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (id) {
            baseAxiosNoInfo('/yuesao_center/config/coperation/detail', {
                params: { coperation_id: id }
            }).then((res: any) => {
                if (res) {
                    res.business_license_url = [{ id: '', response: { data: [res.business_license_url] }, url: res.business_license_url }]

                    form.setFieldsValue({
                        coperation_name: res.coperation_name,
                        contact_man: res.contact_man,
                        contact_phone: res.contact_phone,
                        business_license_url: res.business_license_url,
                        start_date: moment(res.start_date),
                        end_date: moment(res.end_date),
                        status: res.status
                    })
                }
            })

            setPageTitle('编辑合作商')

        } else {
            setPageTitle('新增合作商')
        }
    }, [])

    const uploadFile = (e: { fileList: [] }) => {
        if (Array.isArray(e)) {
            return e
        }

        return e && e.fileList
    }

    const handlePreview = async (file: any) => {
        if (!file.url && !file.preview) {
            file.preview = await ngetBase64(file.originFileObj);

        } else {
            file.preview = file.url;
        }
    }

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )

    const onFinish = (values: any) => {
        let url = id ? '/yuesao_center/config/coperation/update' : '/yuesao_center/config/coperation/add'
        values.business_license_url = values.business_license_url[0].response.data[0]

        axiosHandleEvent.post(url, {
            coperation_id: id,
            coperation_name: values.coperation_name,
            contact_man: values.contact_man,
            contact_phone: values.contact_phone,
            business_license_url: values.business_license_url,
            start_date: values.start_date,
            end_date: values.end_date,
            status: values.status
        })
    }

    return (<div className="common-level2-edit">
        {/* 月嫂中心 -> 月嫂配置 -> 合作商管理 -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={form} name="basic" onFinish={onFinish}>
                <Form.Item label="合作商名称" name="coperation_name" rules={[{ required: true, message: '输入合作商名称' }]} >
                    <Input style={{ width: 320 }} />
                </Form.Item>

                <Form.Item label="联系人" name="contact_man" rules={[{ required: true, message: '输入联系人' }]} >
                    <Input style={{ width: 320 }} />
                </Form.Item>

                <Form.Item label="联系人电话" name="contact_phone" rules={[{ required: true, message: '输入联系人电话' }]} >
                    <Input style={{ width: 320 }} />
                </Form.Item>

                <Form.Item
                    name="business_license_url"
                    label="营业执照"
                    valuePropName="fileList"
                    getValueFromEvent={uploadFile}
                    rules={[{ required: true, message: '必须上传营业执照' }]}
                >
                    <Upload
                        maxCount={1}
                        name="files"
                        onPreview={handlePreview}
                        beforeUpload={beforeUpload}
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                    >
                        {uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item label="开始日期" name="start_date" rules={[{ required: true, message: '必须选择开始日期' }]}>
                    <DatePicker format={dateFormat} />
                </Form.Item>

                <Form.Item label="结束日期" name="end_date" rules={[{ required: true, message: '必须选择结束日期' }]}>
                    <DatePicker format={dateFormat} />
                </Form.Item>

                <Form.Item label="状态" name="status" rules={[{ required: true, message: '必须选择状态' }]}>
                    <Select style={{ width: 160 }} placeholder="请选择状态">
                        <Option value={1} key="1">已启用</Option>
                        <Option value={2} key="1">已停用</Option>
                    </Select>
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    </div>)
}